// this rule disabling could be removed as long as we totally switch to named exports from default exports
// eslint-disable-next-line import/no-named-as-default
import Tabs from "./tabs";

export { Tabs };
export default Tabs;
